import MailingListsWidget from '../components/Widgets/MailingListsWidget';
import type { ConfigData } from '@plone/volto/types';

const applyMailingListsWidget = (config: ConfigData): ConfigData => {

  console.log('Applying mailing lists widget config');
  config.widgets.widget.mailing_lists_widget = MailingListsWidget;

  return config;
};

export default applyMailingListsWidget;
